module.exports = __webpack_public_path__ + "static/media/calendarday.dfc12515.svg";